import type { ConversationPreview } from '@south-street-app/utils';
import type { Conversation } from '@twilio/conversations';

import { useEffect, useState } from 'react';

import { getConversationPreview } from '@south-street-app/utils';

const useConversationPreview = (
  conversation: Conversation | null | undefined,
  refreshKey: number,
) => {
  const [preview, setPreview] = useState<ConversationPreview | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadPreview = async () => {
      if (!conversation) {
        setPreview(null);

        return;
      }

      try {
        const nextPreview = await getConversationPreview(conversation);

        if (isMounted) {
          setPreview(nextPreview);
        }
      } catch {
        if (isMounted) {
          setPreview(null);
        }
      }
    };

    loadPreview().catch(() => undefined);

    return () => {
      isMounted = false;
    };
  }, [conversation, refreshKey]);

  return preview;
};

export { useConversationPreview };
